import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import FixFlowStep from './FixFlowStep'

class LegalAndExtrasStep extends FixFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.fix.steps.legal_and_extras.title'),
      component,
      i18n.t('contract_versions.flows.fix.steps.legal_and_extras.description')
    )
  }
}

export default LegalAndExtrasStep
